import { OnboardingTasksAPIV2 } from '@weave/schema-gen-ts/dist/schemas/insys/onboarding/v2/onboarding-tasks/onboarding_tasks_v2.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaOnboardingTasksV2Service = bindHTTP(OnboardingTasksAPIV2);
export const serviceName = 'onboarding-tasks-v2' as const;
